import { DayOffScreen } from './screens/DayOff';
import { ScreenEmail } from './screens/Email';
import { FlawScreen } from './screens/Flaw';
import { FlirtingStyleScreen } from './screens/FlirtingStyle';
import { HisPastScreen } from './screens/HisPast';
import { HisTypeScreen } from './screens/HisType';
import { HisVoiceScreen } from './screens/HisVoice';
import { HobbiesInterestsScreen } from './screens/HobbiesInterests';
import { HowOftenReachOutScreen } from './screens/HowOftenReachOut';
import { IdealFirstDateScreen } from './screens/IdealFirstDate';
import { ScreenName } from './screens/Name';
import { NoticeFirstScreen } from './screens/NoticeFirst';
import { OutnessScreen } from './screens/Outness';
import { ScreenPersonality } from './screens/Personality';
import { RelationshipImportantScreen } from './screens/RelationshipImportant';
import { RoleInRelationshipScreen } from './screens/RoleInRelationship';
import { ShowLoveScreen } from './screens/ShowLove';
import { SummaryScreen } from './screens/SummaryScreen';
import { WelcomeScreen } from './screens/Welcome';
import { WhatYouWantScreen } from './screens/WhatYouWant';
import { LayoutDataType } from './types';

export const layoutSteps = {
  welcome: {
    component: WelcomeScreen,
    images: [],
  },
  notice_first: {
    component: NoticeFirstScreen,
    images: [],
  },
  his_type: {
    component: HisTypeScreen,
    images: [],
  },
  his_voice: {
    component: HisVoiceScreen,
    images: [],
  },
  show_love: {
    component: ShowLoveScreen,
    images: [],
  },
  personality: {
    component: ScreenPersonality,
    images: [],
  },
  his_past: {
    component: HisPastScreen,
    images: [],
  },
  what_you_want: {
    component: WhatYouWantScreen,
    images: [],
  },
  how_often_reach_out: {
    component: HowOftenReachOutScreen,
    images: [],
  },
  flirting_style: {
    component: FlirtingStyleScreen,
    images: [],
  },
  ideal_first_date: {
    component: IdealFirstDateScreen,
    images: [],
  },
  flaw: {
    component: FlawScreen,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  hobbies_interests: {
    component: HobbiesInterestsScreen,
    images: [],
  },
  outness: {
    component: OutnessScreen,
    images: [],
  },
  relationship_important: {
    component: RelationshipImportantScreen,
    images: [],
  },
  role_in_relationship: {
    component: RoleInRelationshipScreen,
    images: [],
  },
  day_off: {
    component: DayOffScreen,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
  summary: {
    component: SummaryScreen,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  notice_first: null,
  his_type: null,
  his_voice: null,
  show_love: null,
  his_past: null,
  personality: {
    dominant_submissive: 50,
    goofy_serious: 50,
    chaotic_thoughtful: 50,
    curious_certain: 50,
  },
  what_you_want: null,
  how_often_reach_out: null,
  flirting_style: null,
  ideal_first_date: null,
  flaw: null,
  hobbies_interests: null,
  outness: null,
  relationship_important: null,
  role_in_relationship: null,
  day_off: null,
  name: '',
  email: '',
};

// Category constants - not used, it calculates in getCategoryByHisType function
export const HARDCODED_CATEGORIES = [];
